import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';

import Section from '~/components/modules/section';
import Title from '~/components/modules/text/title';
import Carousel from '~/components/modules/carousel';
import Card from '~/components/modules/cards/default';
import Icon from '~/components/modules/icon';

const YrbsSectionStats = ({
	className,
	setCurrentSection,
	statistics,
	factsheets
}) => {
	return (
		<Section
			id="statistics"
			className={`
				pt-12 bg-indigo-150
				${className ?? ''}
			`}
			setCurrentSection={setCurrentSection}
		>
			<div className="container px-4 mb-10">
				<Title className="mb-6 text-center">The YRBS shows us statistics like:</Title>
				<Carousel
					name="statistics"
					loop={false}
					className="max-w-4xl mx-auto"
				>
					{statistics.map(stat => (
						<Card
							key={stat.id}
							image={stat.id}
							variant="gray"
							className="text-center !rounded-none"
							cardBodyClasses="px-4 py-2"
						>
							<h3 className="text-sm font-bold text-indigo-950">{stat.title}</h3>
						</Card>
					))}
				</Carousel>
			</div>

			<Disclosure defaultOpen={true}>
				{({ open }) => (
					<>
						<Disclosure.Button
							className={`
								flex justify-center gap-3 w-full p-3 font-bold text-left text-white focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75 hover:bg-indigo-950/80 hover:text-white focus:bg-indigo-950/80 focus:text-white transition-colors
								${open ? "bg-indigo-950/80" : "bg-indigo-950"}
							`}
						>
							<span>Check out the latest YRBS data — download current <span className="whitespace-nowrap">fact sheets</span></span>
							<Icon
								iconImage="mdi:chevron-down"
								sizeClasses="w-4 h-4"
								className={`transition-transform !transform !translate-y-1 ${open ? "!rotate-180" : ""}`}
								aria-hidden="true"
							/>
						</Disclosure.Button>
						<Transition
							show={open}
							enter="transition duration-100 ease-out"
							enterFrom="transform scale-95 opacity-0"
							enterTo="transform scale-100 opacity-100"
							leave="transition duration-75 ease-out"
							leaveFrom="transform scale-100 opacity-100"
							leaveTo="transform scale-95 opacity-0"
						>
							<Disclosure.Panel
								static
								className="p-4 bg-indigo-950"
							>
								<div className="container px-4">
									<div className="grid auto-rows-auto grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
										{factsheets.map(factsheet => (
											<Card
												key={factsheet.id}
												as="a"
												to={factsheet.file.url}
												image={factsheet.image}
												variant="gray"
												className="group !rounded-none"
												imageContainerClassName="aspect-w-4 aspect-h-3"
												imageObjectPosition="50% 0%"
												imageClassName="!absolute w-full h-full object-cover object-top transition-transform group-hover:scale-110 group-focus:scale-110"
												cardBodyClasses="px-3 py-2"
											>
												<h3 className="mb-0.5 text-xs md:text-2xs font-bold text-indigo-950">{factsheet.title}</h3>

												<div className="relative flex items-center justify-between gap-2 text-2xs md:text-[10px]">
													<p className="uppercase transition group-hover:opacity-0 group-hover:-translate-y-full group-focus:opacity-0 group-focus:-translate-y-full">{factsheet.file.type}, {factsheet.file.size}</p>
													<p className="absolute top-0.5 left-0 opacity-0 translate-y-full transition group-hover:opacity-100 group-hover:translate-y-0 group-focus:opacity-100 group-focus:translate-y-0">Download <span className="uppercase">{factsheet.file.type}</span></p>
													<div className="text-gray-400 transition-colors group-hover:text-indigo-950 group-focus:text-indigo-950">
														<Icon
															iconImage="jam:download"
															sizeClasses="w-5 h-5 md:w-4 md:h-4"
														/>
													</div>
												</div>
											</Card>
										))}
									</div>
								</div>
							</Disclosure.Panel>
						</Transition>
					</>
				)}
			</Disclosure>
		</Section>
	);
};

export default YrbsSectionStats;
